import React from 'react';

import { Clients } from '@ariksa/notification';
import { ClientsApiEditClientRequest } from '@ariksa/notification/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { actions } from 'containers/Setup/Integrations/slice';

import { JiraForm } from './JiraForm';

export const EditJira = () => {
  const { activeClient } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onUpdate = data => {
    const { name, default_assignee, issue_type, board } = data;
    const payload: ClientsApiEditClientRequest = {
      uuid: activeClient.data?.uuid,
      editClientConfig: {
        name,
        jira: {
          default_issue_type: issue_type?.value,
          default_board_name: board?.label,
          default_board_id: board?.value,
          account_id: default_assignee?.value,
          default_assignee_name: default_assignee?.label,
        },
      },
    };
    dispatch(
      actions.updateClientById({
        q: payload,
        onSuccess: () => navigate('/setup/integrations/' + Clients.Jira),
      }),
    );
  };

  return <JiraForm handleSubmit={onUpdate} actionType="Update" />;
};
